"use client";

import { useEffect, useState } from "react";
import styles from "./DrawerIframe.module.scss";
import classNames from "classnames";
import { TTP_PROBOSS_URL } from "../../../config";
import { encryptAES } from ".";

export default function ProbossIframe({ lng, params, portal }) {
  const [iframeSrc, setIframeSrc] = useState("");
  const [loadingIframe, setLoadingIframe] = useState(true);
  const [modalOpened, setModalOpened] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.event === "OPEN_MODAL") {
        setModalOpened(true);
      }

      if (event.data?.event === "CLOSE_MODAL") {
        setModalOpened(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const updateIframeSrc = () => {
    let iframeSrc =
      portal == "CLIENT"
        ? `${TTP_PROBOSS_URL}/${lng}/dashboard` +
          "?params=" +
          encodeURIComponent(encryptAES(params.join("&")))
        : `${TTP_PROBOSS_URL}/${lng}/plan` +
          "?params=" +
          encodeURIComponent(encryptAES(params.join("&")));
    setIframeSrc(iframeSrc);
    setLoadingIframe(true);
  };

  useEffect(() => {
    updateIframeSrc();
  }, [lng]);

  return (
    <div
      className={classNames(styles.wrapper, modalOpened && styles.modalOpen)}
    >
      {/* {loadingIframe && <Loader id="iframe-loader" />} */}
      <iframe
        id="offfcourse-iframe"
        src={iframeSrc}
        className={styles.iframe}
        allow="camera;microphone;autoplay;fullscreen;allow-top-navigation;allow-top-navigation-to-custom-protocols"
        onLoad={() => {
          setLoadingIframe(false);
        }}
      />
    </div>
  );
}
